export default {
	gridList: [],
	rpymAmt: RPYM_AMT(),
	slipScnList: [], //조회조건 전표구분
	ctypeList: [], //조회조건 ctypeList
	clmDd02List: [], //조회조건 검색날짜
	excelDownLoadList: [], //엑셀다운로드시 해더저장
	searchParams: SEARCH_PARAMS(),
	groups: GROUPS()
};
function SEARCH_PARAMS() {
	return {
		dlrCpnyNm: '', //실납품사
		slipScn: '', //전표구분
		ctype: '', //ctype
		clmDd02: '10', //날짜구분값(10.변제확정일 20. R/O확정일)
		causPartNo: '', //품번
		startDcsnDd: '' /*확정일자from*/,
		endDcsnDd: '' /*확정일자to*/
	};
}
function GROUPS() {
	return {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 1
	};
}
function RPYM_AMT() {
	return {
		dcsnMm: '', //확정월
		sumAplRpymAmt01: '', //변제
		sumAplRpymAmt02: '' //이의제기
	};
}
export { SEARCH_PARAMS, GROUPS, RPYM_AMT };
